import { render } from "./OutliersUL.vue?vue&type=template&id=34a66c35"
import script from "./OutliersUL.vue?vue&type=script&lang=js"
export * from "./OutliersUL.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__